<template>
  <div class="item">
    <LazyLoader api-key="gameRank" @init="fetch">
      <div v-if="games.length" class="rank">
        <div class="h-tt">
          <h2>游戏榜单</h2>
        </div>
        <div class="rank-first">
          <a
            :href="`/game-offical/${games[0].game_id}/`"
            class="imgbox"
            target="_blank"
            @click="$util.clickStat(`GWSY/YXBD1`, `官网首页/游戏榜单1`)"
          >
            <img :src="games[0].pic_url" />
            <div class="tab"><em>1</em><span>本周最热</span></div>
            <p class="tit">{{ games[0].title }}</p>
            <p class="desc">{{ games[0].description }}</p>
          </a>
        </div>
        <ol class="rank-list">
          <li v-for="(item, i) in games.slice(1)" :key="item.id">
            <a
              :href="`/game-offical/${item.game_id}/`"
              class="imgbox"
              target="_blank"
              @click="
                $util.clickStat(
                  `GWSY/YXBD${i + 2}`,
                  `官网首页/游戏榜单${i + 2}`
                )
              "
            >
              <img :src="item.img_url" />
              <em class="tab">{{ i + 2 }}</em>
              <p class="tit">{{ item.title }}</p>
              <p class="desc">{{ item.description }}</p>
            </a>
          </li>
        </ol>
      </div>
      <template v-slot:skeleton="{ error, loading }">
        <div class="rank">
          <div class="h-tt"></div>
          <div class="rank-first">
            <Skeleton :error="error" :loading="loading" @retry="fetch" />
          </div>
          <ol class="rank-list">
            <li v-for="i in 8" :key="i">
              <Skeleton :error="error" :loading="loading" @retry="fetch" />
            </li>
          </ol>
        </div>
      </template>
    </LazyLoader>
  </div>
</template>

<script>
export default {
  data() {
    return {
      games: []
    }
  },
  methods: {
    fetch() {
      this.$request('gameRank').then((data) => (this.games = data || []))
    },
    goGame(game_id) {
      this.$router.push({
        path: `/game-offical/${game_id}`
      })
    }
  }
}
</script>
